import { render, staticRenderFns } from "./SchoolProcurementRank.vue?vue&type=template&id=820a8b1a&scoped=true&"
import script from "./SchoolProcurementRank.vue?vue&type=script&lang=js&"
export * from "./SchoolProcurementRank.vue?vue&type=script&lang=js&"
import style0 from "./SchoolProcurementRank.vue?vue&type=style&index=0&id=820a8b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820a8b1a",
  null
  
)

export default component.exports